import { useContext } from "react";
import { Button, Flex, Heading, Modal, Text } from "@cisco/spaces-dash-lib-styleguide";
import { I18nContext } from "../../../contexts/i18nContext";
import QuestionMarkImage from "../../../assets/images/icons/question-mark.svg";

interface PartnerUnauthorizedModalProps {
  isOpen?: boolean;
  closeModal?: () => void;
}

export function PartnerUnauthorizedModal(props: PartnerUnauthorizedModalProps): JSX.Element {
  const { isOpen, closeModal } = props;
  const i18n = useContext(I18nContext);

  if (!i18n) {
    throw new Error("PartnerUnauthorizedModal must be used within an I18nContext.Provider");
  }

  const { t } = i18n;

  return (
    <Modal isOpen={isOpen} size="lg">
      <Flex direction="vertical" align="center" gap={16} style={{ margin: "36px" }}>
        <img width={50} src={QuestionMarkImage} alt="question mark" />
        <Heading>{t("auth.login.login-partner-base.donot-have-permission-to-access", { ns: "spaces-dash-app-partners-login" })}</Heading>
        <Text>{t("auth.login.login-partner-base.contact-admin-to-get-permission", { ns: "spaces-dash-app-partners-login" })}</Text>
        <Button style={{ paddingLeft: "32px", paddingRight: "32px" }} onClick={closeModal}>
          {t("auth.login.login-partner-base.ok-text", { ns: "spaces-dash-app-partners-login" })}
        </Button>
      </Flex>
    </Modal>
  );
}
